import { InventoryType } from "../constants/app-constants";
import { IdName } from "./id-name.interface";
import { AttributeValue } from "./masters/attribute.interface";

export interface JobOrderVendor {
    id?:string,
    jobOrderId?:string,
    jobOrderNo?:string,
    jobOrderInventoryId?:string,
    inventoryId?:string,
    vendorId?:string,
    vendorName?: string,
    serviceId?:string,
    serviceName?: string,
    equipmentId?:string,
    equipmentName?: string,
    startTime?: string;
    endTime?: string | null,
    status?: string | null,
}

export interface JobOrderVendorService {
    id?:string,
    jobOrderId?:string,
    jobOrderNo?:string,
    jobOrderInventoryId?:string,
    inventoryId?:string,
    serviceId:string,
    vendorId?:string,
    equipmentIds?:string[],
    attributes?: JobOrderServiceAttribute[],
    metadata?: JobOrderServiceMetadata,
    startTime?: string;
    endTime?: string | null,
    status?: string | null,
}

export interface JobOrderServiceMetadata {
    vendorName: string,
    serviceName: string,
    equipmentDetails?: {
        id: string
        name: string
    }[]
}

export interface JobOrderServiceAttribute {
    attributeId: string,
    symbol: string,
    name: string,
    values: AttributeValue[];
    displayValue: string;
}

export interface JobOrderServiceForm {
    serviceId:string,
    vendorId:string,
    equipmentIds?:string[],
    attributes?:JobOrderServiceAttribute[],
    appliedInventoryIds?:string[],
}

export interface JobOrderInventory {
    joInvId?:string,
    jobOrderNo?:string,
    jobOrderId?: string;
    inventoryId:string,
    inventoryNo:string,
    inventoryType?:string
    documentType?:string,
    vehicleInfo?: InventoryDetails,
    additionalDetails?:JOInventoryAdditionalInfo
    jobOrderServiceFlatList?: JobOrderVendor[]
    jobOrderServiceList?: JobOrderVendorService[]
}

export interface JobOrderInventoryDetails {
    jobOrderNo: string;
    jobOrderId: string;
    inventoryId: string;
    dueDate: Date;
    issueDate: Date;
    inventoryNo: string;
    jobOrderType: string;
    additionalDetails: any;
}

export interface JobOrderItem {
    id: string,
    igmItemNo: string,
    consigneeId?:string,
    shippingLineId?:string,
    commodityId?:string,
    expectedExamination?:number,
    chaAadhaarNo?:string,
    chaContactNo?:string,
    chaBCHHAPassNo?:string,
    doNo?:string,
    doDate?:Date,
    doValidityDate?:Date,
    deliveryModeFromDO?:string,
    additionalDetails?:any
}

export interface InventoryDetails {
    inventoryId?: string,
    inventoryNo: string,
    nop?: number;
    weight?: number;
    volume?: number;
}

export interface PackageDetails {
    nop: number;
    weight: number;
    volume: number;
}

export interface JobOrderAdditionalInfo {
    destuffTo?: InventoryType;
    noOfVehicles?: number;
    vehicleNos?: string[];
    transporter?: IdName;
    warehouse?: IdName;
    location?: string;
    accountHolder?: IdName;
}

export interface JOInventoryAdditionalInfo {
    sealCutReason?: string;
    expectedExamination?: number;
    associatedItems?: InventoryDetails[];
    joNop?: number;
    joWeight?: number;
    joVolume?: number;
  }


export const allowedJobOrderAdditionalInfoKeys = [
    'noOfVehicles',
    'vehicleNos',
    'destuffTo',
    'warehouseId',
    'warehouseName',
    'transporterId',
    'transporterName',
    'location',
    'expectedExamination'
];